(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/models/enableentry.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/models/enableentry.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.models.EnableEntry = svs.tur.start_subscription.models.Entry.extend({
    defaults() {
      return _.extend(typeof this.constructor.__super__.defaults === 'function' ? this.constructor.__super__.defaults() : this.constructor.__super__.defaults, {
        isAnnouncement: false,
        isEntry: false,
        status: undefined,
        weeklyBetAmount: undefined
      });
    },
    parseEntryOrAnnouncement(data) {
      const entryData = {};
      delete data.requestId;
      delete data.requestInfo;

      entryData.entry = data;
      entryData.entry.subscriptionId = this.get('subscriptionId');

      entryData.isAutogiro = this.CONSTANTS.PAYMENT_TYPE.AUTOGIRO.TYPE === data.currPaymentType;
      entryData.isBankcard = this.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE === data.currPaymentType;
      entryData.hasActivePayChannel = Boolean(data.paychActive);
      entryData.hasChangeablePayChannel = data.paymentTypeChangePossible;
      if (data.enableType === this.CONSTANTS.ENABLE_TYPE.ANNOUNCEMENT) {
        entryData.isAnnouncement = true;
        entryData.amount = data.announcement.intervalAmount;
        entryData.paymentTypeText = this.CONSTANTS.PAYMENT_TYPE[data.currPaymentType].TEXT;
        entryData.payTime = data.payTime;
      }
      if (data.enableType === this.CONSTANTS.ENABLE_TYPE.ENTRY) {
        entryData.isEntry = true;
        entryData.amount = data.entryInfo.amount;
        entryData.startTime = data.entryInfo.startTime;
        entryData.stopTime = data.entryInfo.stopTime;
      }
      return entryData;
    },
    parseNewSubscription(data) {
      return {
        newSubId: data.newSubId
      };
    },
    getEntryOrAnnouncement(options) {
      options = options || {};
      const model = this;
      const context = options.context;
      const successCallback = options.success;

      options.success = function (response) {
        const attr = model.parseEntryOrAnnouncement(response);
        model.set(attr);
        svs.components.loader.hide();
        successCallback && successCallback.call(context, model, response, options);
      };
      options.error = model.parseError;

      options.url = "".concat(svs.core.jupiter.url(), "/subscription/2/enableentry");
      options.attrs = {
        subscriptionId: this.get('subscriptionId')
      };
      svs.components.loader.show();
      this.sync('create', this, options);
    },
    postNewSubscription(options) {
      options = options || {};
      const model = this;
      const context = options.context;
      const successCallback = options.success;

      options.success = function (response) {
        const attr = model.parseNewSubscription(response);
        model.set(attr);
        svs.components.loader.hide();
        successCallback && successCallback.call(context, model, response, options);
      };
      options.error = model.parseError;

      options.url = "".concat(svs.core.jupiter.url(), "/subscription/3/enablesubscription");
      options.attrs = this.get('entry');
      svs.components.loader.show();
      this.sync('update', this, options);
    },
    reset() {
      const subId = this.get('subscriptionId');
      this.constructor.__super__.reset.apply(this, arguments);
      this.set('subscriptionId', subId, {
        silent: true
      });
    }
  });
})(Backbone, _, svs);

 })(window);